/* ARCHIVO: assets/wetuning-ui.js
   Utilidades de interfaz: revelado al hacer scroll (.wt-fade-up) y
   contadores animados (data-wt-counter). Sin dependencias externas. */

(function () {
  document.documentElement.classList.add('wt-js');

  // Revelado al hacer scroll
  var revealTargets = document.querySelectorAll('.wt-fade-up');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Contadores animados
  var counters = document.querySelectorAll('[data-wt-counter]');

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-wt-counter'), 10);
    if (isNaN(target)) { return; }
    var duration = 1200;
    var start = null;

    function step(timestamp) {
      if (!start) { start = timestamp; }
      var progress = Math.min((timestamp - start) / duration, 1);
      var value = Math.floor(progress * target);
      el.textContent = value.toLocaleString('es-CL');
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString('es-CL');
      }
    }
    window.requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window && counters.length) {
    var counterObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    counters.forEach(function (el) { counterObserver.observe(el); });
  } else {
    counters.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-wt-counter'), 10);
      if (!isNaN(target)) { el.textContent = target.toLocaleString('es-CL'); }
    });
  }
})();